import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=6cf423cd&scoped=true&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"
import style0 from "./Page.vue?vue&type=style&index=0&id=6cf423cd&prod&scoped=true&lang=css&"
import style1 from "./Page.vue?vue&type=style&index=1&id=6cf423cd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf423cd",
  null
  
)

export default component.exports